"use strict";

var _slicedToArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRef = setRef;
exports.withView = exports.ViewContext = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./View.css");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function setRef(ref, value) {
  if (ref == null) return;
  if ('current' in ref) ref.current = value;else if (ref instanceof Function) ref(value);
}

var ViewContext = (0, _react.createContext)(undefined);
exports.ViewContext = ViewContext;
ViewContext.displayName = 'View';

var View = function View(_ref2, ref) {
  var id = _ref2.id,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      style = _ref2.style,
      children = _ref2.children;

  var _ref3 = (0, _react.useState)(undefined),
      _ref4 = _slicedToArray(_ref3, 2),
      view = _ref4[0],
      setView = _ref4[1];

  var canvasRef = (0, _react.useCallback)(function (canvas) {
    canvas && setView(canvas);
    setRef(ref, canvas);
  }, []);
  return _react.default.createElement("div", {
    id: id,
    className: "".concat(className && "".concat(className, " "), "Furegame"),
    style: style
  }, _react.default.createElement("canvas", {
    ref: canvasRef
  }), view && _react.default.createElement(ViewContext.Provider, {
    value: view
  }, children));
};

var withView = function withView(displayName, Component, ext) {
  Component.displayName = displayName;

  var WithView = function WithView(_ref, ref) {
    var id = _ref.id,
        className = _ref.className,
        style = _ref.style,
        props = _objectWithoutProperties(_ref, ["id", "className", "style"]);

    return View({
      id: id,
      className: className,
      style: style,
      children: _react.default.createElement(Component, props)
    }, ref);
  };

  WithView.displayName = "".concat(displayName, ".View");
  var WithExt = (0, _react.forwardRef)(WithView);
  ext && Object.entries(ext).forEach(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        name = _ref6[0],
        value = _ref6[1];

    WithExt[name] = value; // eslint-disable-line @typescript-eslint/no-explicit-any
  });
  return WithExt;
};

exports.withView = withView;